/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { call, put, SagaReturnType, takeLatest } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import api from "_config/api";
import {
  AnexoResumo,
  EstiloConsultaPrevia,
  ParametroUrbanistico,
  UsoSolo,
  VersaoPublicada
} from "../types";

export interface ObterZonaPorSiglaRequest {
  sigla: string;
}

export interface ZonaPublicadaDetalhe {
  versao: VersaoPublicada;
  id: string;
  sigla: string;
  nome: string;
  descricao?: string | null;
  tipo: string;
  estilo: EstiloConsultaPrevia;
  /** Quantas manchas do mapa compõem a zona. Pode ser 0: existe na ficha, não no mapa. */
  totalGeometrias: number;
  parametros: ParametroUrbanistico[];
  usosSolo: UsoSolo[];
  anexos: AnexoResumo[];
}

interface State {
  isRequesting: boolean;
  successPayload: ZonaPublicadaDetalhe | null;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  successPayload: null,
  errors: []
};

const obterZonaPorSiglaSlice = createSlice({
  name: "consultaprevia@obterZonaPorSigla",
  initialState,
  reducers: {
    obterZonaPorSigla: (
      state,
      action: PayloadAction<ObterZonaPorSiglaRequest>
    ): void => {
      state.isRequesting = true;
      state.successPayload = null;
      state.errors = [];
    },
    obterZonaPorSiglaSuccess: (
      state,
      action: PayloadAction<ZonaPublicadaDetalhe>
    ): void => {
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    obterZonaPorSiglaFailed: (state, action: PayloadAction<string[]>): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    },
    reset: (state): void => {
      state.isRequesting = false;
      state.successPayload = null;
      state.errors = [];
    }
  }
});

function* sagaFunction(params: {
  type: string;
  payload: ObterZonaPorSiglaRequest;
}) {
  try {
    // A sigla vem da rota e pode conter caracteres que quebram o path.
    const sigla = encodeURIComponent(params.payload.sigla);

    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      `api/v1/cidadao/consulta-previa/zonas/${sigla}`
    );

    const { data }: { data: ZonaPublicadaDetalhe } = response;

    yield put(obterZonaPorSiglaSuccess(data));
  } catch (error) {
    yield put(obterZonaPorSiglaFailed(formatError(error)));
  }
}

export const {
  obterZonaPorSigla,
  obterZonaPorSiglaSuccess,
  obterZonaPorSiglaFailed,
  reset
} = obterZonaPorSiglaSlice.actions;
export const { reducer } = obterZonaPorSiglaSlice;
export const saga = takeLatest(obterZonaPorSigla.type, sagaFunction);
